import type { ListBuilderConfiguration } from '../../types';
import { allLocationsList } from './lists/all-locations';
import { allMerchandisersList } from './lists/all-merchandisers';
import { highTempMerchandisersList } from './lists/high-temp-merchandisers';
import { inactiveMerchandisersList } from './lists/inactive-merchandisers';
import { lowStockMerchandisersList } from './lists/low-stock-merchandisers';
import { maintenanceMerchandisersList } from './lists/maintenance-merchandisers';

/**
 * Location list configuration
 * Multiple views for locations: All, Merchandisers by status, Low Stock, High Temp
 */
export const LOCATION_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		allLocationsList,
		allMerchandisersList,
		inactiveMerchandisersList,
		maintenanceMerchandisersList,

		lowStockMerchandisersList,
		highTempMerchandisersList,
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: ['locationType', 'locationStatus', 'stockLevel', 'highTemp'],
		filterContexts: {
			locationType: {
				hideInContexts: ['warehouses'],
			},
		},
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/locations/:id',
			objectLabel: 'Location',
			objectTable: 'location',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'code', fieldLabel: 'Code' },
				{ fieldName: 'description', fieldLabel: 'Description' },
				{ fieldName: 'type', fieldLabel: 'Type' },
				{ fieldName: 'locationCode', fieldLabel: 'Location Code' },
				{ fieldName: 'capacity', fieldLabel: 'Capacity' },
				{ fieldName: 'units', fieldLabel: 'Units' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'clientAddressId', fieldLabel: 'Client Address ID' },
				{ fieldName: 'warehouseId', fieldLabel: 'Warehouse ID' },
				{ fieldName: '_created_date', fieldLabel: 'Created Date' },
			],
		},
	],
	tableSorts: [
		{
			id: 'code',
			name: 'Code',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort locations by code',
		},
		{
			id: 'type',
			name: 'By Type',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'type',
					objectTable: 'location',
				},
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort by location type then code',
		},
		{
			id: 'capacity',
			name: 'By Capacity',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'capacity',
					objectTable: 'location',
				},
			],
			description: 'Sort by capacity (highest first)',
		},
		{
			id: 'status',
			name: 'By Status',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'status',
					objectTable: 'location',
				},
				{
					direction: 'ASC',
					fieldName: 'code',
					objectTable: 'location',
				},
			],
			description: 'Sort by status then code',
		},
	],
};
